import { bootstrapPortal } from "@/shared/app/bootstrapPortal";
import AgentApp from "./App.agent";

bootstrapPortal("agent", <AgentApp />);
